import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {LocalStorageService} from 'ngx-webstorage';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class searchService {

  private serverUrl = environment.serverUrl;

  constructor(
    private http: HttpClient,
    private localSt: LocalStorageService  ) {}

  findItems(value, date): Observable<any> {
    return this.http.get(this.serverUrl + 'items/withcategoryandsearch?page=1&limit=10&search=' + value + '&date=' + date + '&order=desc');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/search.service.ts